import * as ngCommon from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';

import { UtilsModule } from '@shared/utils/utils.module';
import { AbpModule } from '@abp/abp.module';
import { CommonModule } from '@shared/common/common.module';

import { TimeZoneComboComponent } from './timing/timezone-combo.component';
import { AppAuthService } from './auth/app-auth.service';
import { JqPluginDirective } from './libs/jq-plugin.directive';
import { CommonLookupModalComponent } from './lookup/common-lookup-modal.component';
import { DateRangePickerComponent } from './timing/date-range-picker.component';
import { DatePickerDirective } from './timing/date-picker.component';
import { AppRouteGuard } from './auth/auth-route-guard';
import { DateTimeService } from './timing/date-time.service';
import { AppLocalizationService } from '@app/shared/common/localization/app-localization.service';
import { AppNavigationService } from '@app/shared/layout/nav/app-navigation.service';
import { DataTableModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { WeekSwitcherService } from '@app/shared/services/week-switcher.service';
import { ListFilterService } from '@app/shared/services/list-filter.service';
import { ParentIdFilterPipe } from './pipes/parent-id-filter.pipe';
import { ClickFocusoutDirective } from '@app/shared/common/directives/click-focusout.directive';
import { CanDeactivateGuardService } from '@app/shared/services/can-deactivate-guard.service';
import { ConsultantDisplayNamePipe } from './pipes/consultant-display-name.pipe';
import { HourMinutesPipe } from '@app/shared/common/pipes/hour-minutes.pipe';
import { EmployeeSearchFilterPipe } from './pipes/employee-search-filter.pipe';
import { SearchFilterPipe } from './pipes/search-filter.pipe';
import { BracketPipe } from './pipes/bracket.pipe';

@NgModule({
    imports: [
        ngCommon.CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        UtilsModule,
        AbpModule,
        CommonModule,
        DataTableModule,
        PaginatorModule
    ],
    declarations: [
        TimeZoneComboComponent,
        JqPluginDirective,
        CommonLookupModalComponent,
        DateRangePickerComponent,
        DatePickerDirective,
        ParentIdFilterPipe,
        ClickFocusoutDirective,
        ConsultantDisplayNamePipe,
        HourMinutesPipe,
        EmployeeSearchFilterPipe,
        SearchFilterPipe,
        BracketPipe
    ],
    exports: [
        TimeZoneComboComponent,
        JqPluginDirective,
        CommonLookupModalComponent,
        DateRangePickerComponent,
        DatePickerDirective,
        ParentIdFilterPipe,
        ClickFocusoutDirective,
        ConsultantDisplayNamePipe,
        HourMinutesPipe,
        EmployeeSearchFilterPipe,
        SearchFilterPipe,
        BracketPipe
    ],
    providers: [
        DateTimeService,
        AppLocalizationService,
        AppNavigationService,
        WeekSwitcherService,
        ListFilterService,
        CanDeactivateGuardService
    ]
})
export class AppCommonModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AppCommonModule,
            providers: [AppAuthService, AppRouteGuard]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/app-common.module.ts